var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/moon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/moon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8853932,14.1416818 C15.7169972,16.1082771 13,20.308718 13,25 C13,31.627417 18.372583,37 25,37 C28.6317944,37 31.999932,35.3754326 34.2640371,32.6267491 C34.7908559,31.9871771 34.3558868,31.0211209 33.5278054,30.991596 C26.549465,30.7427863 21,25.0039356 21,18 C21,17.0686519 21.0977784,16.1503949 21.2897989,15.2559902 C21.4636248,14.4463333 20.6343328,13.7883418 19.8853932,14.1416818 Z",
    id: "Path",
    fill: "#272727",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.04bf7aa89c2af1880fdde2130bfa9ee0.svg";
export { ForwardRef as ReactComponent };